export const PSH = {
    page: 'product-shot-history-page',
    breadcrumbSection: 'product-shot-history-page__breadcrumb-section',
    loadingSection: 'product-shot-history-page__loading-section',
    searchRow: 'product-shot-history-page__search-row',
    searchField: 'product-shot-history-page__search-field',
    searchActions: 'product-shot-history-page__search-actions',
    shotStepper: 'product-shot-history-page__shot-stepper',
    shotStepLabel: 'product-shot-history-page__shot-step-label',
    contentSection: 'product-shot-history-page__content-section',
    summaryCard: 'product-shot-history-page__summary-card',
    summaryImage: 'product-shot-history-page__summary-image',
    summaryDetails: 'product-shot-history-page__summary-details',
    timelineSection: 'product-shot-history-page__timeline-section',
    timelineItem: 'product-shot-history-page__timeline-item',
    cancellationBox: 'product-shot-history-page__cancellation-box',
    exportButtonWrap: 'product-shot-history-page__export-button-wrap',
} as const;
